/**
 * Décalage titres proposal — aligné sur gridConfig.calculateLeftPadding /
 * calculateWidth (indentationFactor = niveau - 1 ou indexTitle.length - 1).
 */

import { gridUnit } from '../../constants/gridConfig';
import { proposalPxToSpacingCss } from './proposalUnits';
import { normalizeHorizontalAlign } from './proposalBoxAlign';

/**
 * Facteur d'indentation legacy (0 pour title1, 1 pour title2, …).
 * @param {number} titleLevel 1..4
 * @param {number[]|null} [indexTitle]
 * @param {{ fromLevelOnly?: boolean }} [options] — éditeur web : niveau sidebar prioritaire
 */
export function resolveTitleIndentFactor(titleLevel, indexTitle = null, options = {}) {
  const level = Number(titleLevel) || 1;
  if (options.fromLevelOnly) {
    return Math.max(0, level - 1);
  }
  if (Array.isArray(indexTitle) && indexTitle.length > 0) {
    return Math.max(0, indexTitle.length - 1);
  }
  return Math.max(0, level - 1);
}

/**
 * Indentation en px : gridUnit × indentationTitles × facteur.
 * @param {object} configuration
 * @param {number} titleLevel
 * @param {number[]|null} [indexTitle]
 * @param {{ fromLevelOnly?: boolean }} [options]
 */
export function computeTitleIndentPx(configuration, titleLevel, indexTitle = null, options = {}) {
  const units = Number(configuration?.indentationTitles) || 0;
  if (units <= 0) return 0;
  const factor = resolveTitleIndentFactor(titleLevel, indexTitle, options);
  if (factor <= 0) return 0;
  return gridUnit * units * factor;
}

function indentToCss(indentPx, drawMode) {
  if (!indentPx || indentPx <= 0) return null;
  return drawMode ? `${indentPx}px` : (proposalPxToSpacingCss(indentPx) || null);
}

/**
 * Mise en page bloc titre — margin-left auto + largeur réduite (legacy flow).
 * Pas de flex-end parent (écrase la largeur en mode shrink).
 */
export function buildTitleBlockLayoutCss({
  indentPx,
  horizontal = 'left',
  drawMode = false,
}) {
  const indentCss = indentToCss(indentPx, drawMode);
  const h = normalizeHorizontalAlign(horizontal);
  const base = {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
  };

  if (!indentCss) {
    return base;
  }

  const narrowed = {
    ...base,
    width: `calc(100% - ${indentCss})`,
    maxWidth: `calc(100% - ${indentCss})`,
  };

  if (h === 'end') {
    return { ...narrowed, marginLeft: 'auto', marginRight: 0 };
  }
  if (h === 'center') {
    return { ...narrowed, marginLeft: 'auto', marginRight: 'auto' };
  }
  return {
    ...base,
    paddingLeft: indentCss,
  };
}

/** @deprecated utiliser buildTitleBlockLayoutCss */
export function buildTitleIndentWrapperCss(opts) {
  return buildTitleBlockLayoutCss(opts);
}
